// @flow

import { combineReducers, type Reducer } from "redux";
import hierarchy from "./hierarchy";
import absenceReasons from "./absence-reasons";
import absenceReview from "./absence-review";
import alerts from "./alerts";
import employeeAbsences from "./employee-absences";
import employeeNotifications from "./employee-notifications";
import shiftPatterns from "./shift-patterns";
import staffGroups from "./staff-groups";
import serviceSectionStatuses from "./service-section-statuses";
import employeePositions from "./employee-positions";
import specialContactTypes from "./special-contact-types";
import selectEmployee from "./select-employee";

import { initialState as hierarchyInitialState } from "./hierarchy/state";
import { initialState as absenceReasonsInitialState } from "./absence-reasons/state";
import { initialState as absenceReviewInitialState } from "./absence-review/state";
import { initialState as alertsInitialState } from "./alerts/state";
import { initialState as employeeAbsencesInitialState } from "./employee-absences/state";
import { initialState as employeeNotificationsInitialState } from "./employee-notifications/state";
import { initialState as shiftPatternsInitialState } from "./shift-patterns/state";
import { initialState as staffGroupsInitialState } from "./staff-groups/state";
import { initialState as serviceSectionStatusesInitialState } from "./service-section-statuses/state";
import { initialState as employeePositionsInitialState } from "./employee-positions/state";
import { initialState as specialContactTypesInitialState } from "./special-contact-types/state";
import { initialState as selectEmployeeState } from "./select-employee";

import type { SharedState } from "./types";

export const initialState: SharedState = {
  hierarchy: hierarchyInitialState,
  absenceReasons: absenceReasonsInitialState,
  absenceReview: absenceReviewInitialState,
  alerts: alertsInitialState,
  employeeAbsences: employeeAbsencesInitialState,
  employeeNotifications: employeeNotificationsInitialState,
  shiftPatterns: shiftPatternsInitialState,
  staffGroups: staffGroupsInitialState,
  serviceSectionStatuses: serviceSectionStatusesInitialState,
  employeePositions: employeePositionsInitialState,
  specialContactTypes: specialContactTypesInitialState,
  selectEmployee: selectEmployeeState,
};

export default (combineReducers({
  hierarchy,
  absenceReasons,
  absenceReview,
  alerts,
  employeeAbsences,
  employeeNotifications,
  shiftPatterns,
  staffGroups,
  serviceSectionStatuses,
  employeePositions,
  specialContactTypes,
  selectEmployee,
}): Reducer<SharedState, *>);
